import { render, staticRenderFns } from "./leader-calendar.vue?vue&type=template&id=33472abe&scoped=true"
import script from "./leader-calendar.vue?vue&type=script&lang=js"
export * from "./leader-calendar.vue?vue&type=script&lang=js"
import style0 from "./leader-calendar.vue?vue&type=style&index=0&id=33472abe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33472abe",
  null
  
)

export default component.exports